import '@shui/core/sh-tag';

import { Component, input, booleanAttribute, output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'sh-tag',
    template: '<ng-content />',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[attr.accessible-remove-label]': 'accessibleRemoveLabel() ?? null',
        '[attr.active]': 'active() ? "" : null',
        '[attr.color]': 'color() ?? null',
        '[attr.condensed]': 'condensed() ? "" : null',
        '[attr.disabled]': 'disabled() ? "" : null',
        '[attr.label]': 'label() ?? null',
        '[attr.removable]': 'removable() ? "" : null',
        '[attr.selectable]': 'selectable() ? "" : null',
        '(closed)': 'closed.emit($event)'
    }
})
export class ShTagComponent {
    /**
     * Defines the accessible label for the remove icon. If not provided, it will default to
     * "Remove" followed by the tag label (e.g., "Tag1 Remove").
     */
    public readonly accessibleRemoveLabel = input<string | undefined>(undefined);

    /**
     * If the tag is selectable, defines the active state of the tag. If set to true, the style will
     * adapt to represent that the item is currently active.
     */
    public readonly active = input(false, { transform: booleanAttribute });

    /** Defines the color of the tag. To see all color variables, check the Colors page. */
    public readonly color = input<string | number | undefined>(undefined);

    /** Adds condensed styles if set to true. */
    public readonly condensed = input(false, { transform: booleanAttribute });

    /** If set to `true`, will update the styles and disable pointer events. */
    public readonly disabled = input(false, { transform: booleanAttribute });

    /** Defines the label shown on the tag. */
    public readonly label = input<string | number | undefined>(undefined);

    /** Defines whether a tag can be removed or not. Adds a close icon next to the tag. */
    public readonly removable = input(false, { transform: booleanAttribute });

    /** Defines whether the tag is selectable or not. */
    public readonly selectable = input(false, { transform: booleanAttribute });

    public readonly closed = output<Event>();
}
